export enum ProductCategories {
  Shelf = 'shelf',
  Item = 'item',
}
